
<template>

  <div class="row">
    <button @click="api">Api</button>
    <button @click="getUser">getUser</button>
    <button @click="userInfo">userInfo</button>
    <button @click="getTenant">getTenant</button>
  </div>
</template>

<script>
import identityHandler from '@/core/identity-handler'

export default {
  name: 'Login',
  data() {
    return {
      user: null,
      signedIn: false
    }
  },
  methods: {
    userInfo() {
      identityHandler.mgr.getUser().then(function(user) {
        var url = window.runtimeConfig.idServerAuthority + '/connect/userinfo'

        var xhr = new XMLHttpRequest()
        xhr.open('GET', url)
        xhr.onload = function() {
          console.log(xhr.status, JSON.parse(xhr.responseText))
        }
        xhr.setRequestHeader('Authorization', 'Bearer ' + user.access_token)
        xhr.send()
      })
    },
    api() {
      identityHandler.mgr.getUser().then(function(user) {
        var url = window.runtimeConfig.idServerAuthority + '/identity'

        var xhr = new XMLHttpRequest()
        xhr.open('GET', url)
        xhr.onload = function() {
          console.log(xhr.status, JSON.parse(xhr.responseText))
        }
        xhr.setRequestHeader('Authorization', 'Bearer ' + user.access_token)
        xhr.send()
      })
    },
    getUser() {
      identityHandler.mgr.getUser().then(function(user) {
        if (user) {
          console.log('User logged in', user.profile)
        } else {
          console.log('User not logged in')
        }
      })
    },
    getTenant() {
      identityHandler.getTenant()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue